import { useEffect } from "react";

const SEO = ({ pageTitle }) => {
  useEffect(() => {
    document.title = pageTitle != 'The EngineersBay' ? pageTitle + " | The EngineersBay" : pageTitle;

    // Remove existing canonical tag (if exists)
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.remove();
    }

    // Get current URL
    const currentUrl = window.location.origin + window.location.pathname;

    // Create new canonical link
    const link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute("href", currentUrl);
    document.head.appendChild(link);

  }, []);
};

export default SEO;